import React from 'react';

import { Control } from 'react-hook-form';
import { useSelector } from 'react-redux';

import Button from 'components/shared/Button';
import FormActions from 'components/shared/FormAdapters/FormDefault/FormActions';
import { HookCheckbox } from 'components/shared/HookFormComponents';
import Text from 'components/shared/Typography/Text';
import { itineraryDetailsModeSelector } from 'store/itinerariesItem/selectors';
import { capitalize } from 'utils/common';

import styles from './index.module.css';
import { useSyncCalendarForm } from './useSyncCalendarForm';

export const SyncToCalendarForm = () => {
  const { methods, eventTypes, handleCopy, handleSave } = useSyncCalendarForm();
  const { control, formState } = methods;
  // TODO: rework control props for adapters & delete it
  const depricatedControl = control as Control<any>;

  const detailsMode = useSelector(itineraryDetailsModeSelector);
  const isV2 = detailsMode === 'chronological';

  const isButtonDisbled = !isV2 ? false : !formState.isValid;

  return (
    <div className={styles.wrapper}>
      <div className={styles.titleContainer}>
        <Text className={styles.title}>Sync to Calendar</Text>
      </div>

      <div className={styles.checkboxContainer}>
        {isV2 ? (
          <>
            <Text className={styles.description}>
              Select the types of events you’d like to subscribe to on your calendar.
            </Text>
            <div className={styles.checkboxList}>
              {eventTypes?.map((type) => (
                <HookCheckbox
                  key={type}
                  name={type}
                  control={depricatedControl}
                  className={styles.checkbox}
                  isDisabled={formState.isSubmitting}
                >
                  {capitalize(type)}
                </HookCheckbox>
              ))}
            </div>
          </>
        ) : (
          <Text className={styles.description}>Click the Sync Events button to push all events to your calendar.</Text>
        )}
      </div>

      <div className={styles.buttonRow}>
        <FormActions isRight>
          <Button
            type="primary2"
            onClick={handleCopy}
            loading={formState.isSubmitting}
            size="medium"
            disabled={isButtonDisbled}
          >
            Copy Link
          </Button>

          <Button onClick={handleSave} loading={formState.isSubmitting} size="medium" disabled={isButtonDisbled}>
            Sync Events
          </Button>
        </FormActions>
      </div>
    </div>
  );
};
